<template>
  <div class="bg-white p-4 pt-3 sm:pt-4 sm:p-6 rounded">
    <slot />
  </div>
</template>
